<template>

    <div>
        <!-- <div class="alignCenter paddingV8" v-show="status == 'loading'">
            <i class="icon spinner-loader"></i>
        </div> -->
        <div class="hiddenOverflow bgF6F6F6" style="width:100%;">
            <div style="background: #FFFBF0;">
                <!--                <img style="width:100%;height:170px;" src="icon/userIcon/me_bg.png" alt="" srcset="">-->
                <!-- <img style="position: absolute;top:-40px;left:-18%" src="icon/userIcon/left_bg.svg" alt="">
                <img style="position: absolute;top:-53px;left:42%" src="icon/userIcon/right_bg.svg" alt=""> -->
                <div class="user_card">
                    <!-- <a href="//h5.shixun365.com/shixun-mobile/html/me/set.html">
                        <img class="set_icon" style="" src="icon/userIcon/set_icon.svg" alt="">
                    </a> -->
                    <img @click="$router.push({name:'operationMainintegral',params:{name:'integral',index:1}})"
                         class="sign_icon" style="" src="icon/userIcon/sign_icon.svg" alt="">

                    <div class="user_message flexLayout">
                        <div style="width:56px;height:56px;border:2px solid #fff;border-radius:50%;box-sizing:border-box;">
                            <a v-if="dataItem"
                               :href="externalApp.oldShixun.baseUrl + 'html/me/mydetails.html?id='+ dataItem.userId">
                                <img class="cover user_photo" :src="dataItem ? dataItem.headerImg : ''" alt="">
                            </a>
                        </div>
                        <div class="user_param">
                            <div class="user_name">
                                <span class="marginR16 font20r">{{dataItem ? dataItem.userName : ''}}</span>
                                <span class="font14r inlineBlock" style="line-height: 16px;" @click="goToProfilesPage()">
                                    <i class="icon editIcon size16 floatL marginR4"></i>
                                    编辑
                                </span>
                            </div>
                            <div class="user_invite">
                                <!--                                <div class="mrAndfont" v-if="dataItem ? dataItem.isVip() : false">-->
                                <!--                                    {{dataItem.getVipDueTime().substr(0, 10)}} 会员到期-->
                                <!--                                </div>-->
                                <div class="mrAndfont copyAction"
                                     :data-clipboard-text="dataItem ? dataItem.introduceCode : ''">
                                    <span>账号: {{dataItem ? dataItem.introduceCode : ''}}</span>
                                    <img style="margin-left:4px;width:8px;height:8px;" src="icon/userIcon/copy_icon.png"
                                         alt="复制图标">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="marginT8 font14r" style="padding: 0 18px; color: #b58600;"
                         v-if="dataItem && dataItem.isVipType('super')">
                        SVIP 有效期至：{{dataItem.vipDueTime[1]}}
                    </div>

                    <div class="marginT8 font14r" style="padding: 0 18px; color: #b58600;"
                         v-if="dataItem && dataItem.isCampusVip">
                        园区VIP 有效期至：{{dataItem.vipDueTime[10]}}
                    </div>

                    <div class="marginT8 font14r" style="padding: 0 18px; color: #b58600;"
                         v-if="dataItem && dataItem.isCampusVipUser">
                        园区四大会员 有效期至：{{dataItem.campusVipUserEndTime}}
                    </div>

                    <me-vip-info :vipInfo="vipInfo" @renewVip="renewal"></me-vip-info>
                </div>
            </div>

            <!-- 横向排列的图标按钮模块 -->
            <instrument/>


<!--            <div class="ad_model">-->
<!--                <router-link to="/vip">-->
<!--                    <img src="icon/userIcon/user_ad.png" alt="">-->
<!--                </router-link>-->
<!--            </div>-->

            <!--v-if -->
<!--            <router-link class="park block" to="/myPark"-->
<!--                 v-if="dataItem && dataItem.parkId != null && dataItem.parkId != ''">-->
<!--                <span>进入园区</span>-->
<!--            </router-link>-->

            <router-link class="park block" :to="{name : 'underlineCourseSponsorPersonalCenter'}"
                 v-if="dataItem && dataItem.isVipType('underline_course_sponsor')">
                <span>进入主办方</span>
            </router-link>

            <div class="paddingH16 marginT16">
                <router-link class="block white_bg paddingV12 lineHeight20r16f roundBorder8 alignC color333 fWeight500" :to="{name : 'appDownload'}">
                    下载师讯APP
                </router-link>
            </div>

            <div class="paddingH16">

                <!-- 权益中心 -->
                <authCenter :userInfo="dataItem"/>
                <!-- <purchase-center/>      -->
<!--                <materialObjectCenter/>-->

                <!-- 广告 -->
                <bannerModule3Vue type="40"  version="4" style="margin-top:5px;margin-bottom:5px"/>

                <learn-center style="margin-top:0px"/>

                <!-- 帮助中心 -->
                <help-center/>
                <bannerModule3Vue type="38" version="4" style="margin-top:5px;margin-bottom:5px"/>
            </div>

            <!-- 乱七八糟的 -->
            <div class="otherMenu paddingH16">

                <div class="white_bg roundBorder8 hiddenOverflow">
                    <div class="formRow clearfix bold" style="border-bottom: none 0;">
                        师讯中心
                    </div>
                    <div class="formRow clearfix">
                        <div class="columnName">客服电话</div>
                        <div class="columnValue">
                            <a class="grey" href="tel:0757-82907557">0757-82907557</a>
                        </div>
                    </div>
<!--                    <div class="formRow clearfix">-->
<!--                        <div class="columnName">关于师讯</div>-->
<!--                        <div class="block columnValue" @click="aboutUs()">-->
<!--                            <i class="fa fa-angle-right"></i>-->
<!--                        </div>-->
<!--                    </div>-->
                    <router-link :to="{name : 'appDownload'}"  class="formRow clearfix">
                        <div class="columnName">APP 下载</div>
                        <div class="block columnValue">
                            <i class="fa fa-angle-right"></i>
                        </div>
                    </router-link>
<!--                    <router-link :to="{name : 'guide'}"  class="formRow clearfix">-->
<!--                        <div class="columnName">师讯指南</div>-->
<!--                        <div class="block columnValue">-->
<!--                            <i class="fa fa-angle-right"></i>-->
<!--                        </div>-->
<!--                    </router-link>-->
                </div>

            </div>

            <div class="debugArea" @click="toggleDebug()"></div>

            <div style="height: 64px;"></div>

            

            <bottomMenu ref="bottomMenu" activePath="/me"></bottomMenu>
        </div>

        <!-- <div class="paddingV16 alignC" v-if="status == 'ready' && !dataItem">
            查不到用户数据
        </div> -->

        <vipRenewalDrawer ref="vipRenewalDrawer" type="payVip"
              :vipType="activeVipType"
              :productData="productData" :agreeServiceProtocol="agreeServiceProtocol"
              :onPaySuccess="onPaySuccess"
              @changeAgreeServiceProtocol="changeAgreeServiceProtocol"/>

        <div class="articleEntry absolutePosition" style="width: 90px; height: 67px; top: 70px; right: 13px"
            @click="goToArticlePage()"></div>

    </div>


</template>
<script>

// lib
import ClipboardJS from 'clipboard';
import bannerModule3Vue from '../../components/ad/bannerModule3.vue';

// config
import appConfig from '../../appConfig';

// data
import externalApp from '@data/externalApp';
import vipTypeEnum2 from "@data/vipTypeEnum2";

// api
import vipApi from "@api/vip";

// platformApi
import requestManager from "@comp/platformApi/requestManager";

// modules
import bottomMenu from '@comp/bottomMenu.vue';

import MeVipInfo    from "./meComp/meVipInfo";
import instrument   from './meComp/instrument.vue';
import authCenter   from './meComp/authCenter.vue';
import purchaseCenter  from './meComp/purchaseCenter.vue';
import materialObjectCenter  from './meComp/materialObjectCenter.vue';
import learnCenter  from './meComp/learnCenter.vue';
import helpCenter   from './meComp/helpCenter.vue';
import vipRenewalDrawer from '@comp/drawer/vipRenewalDrawer'

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// platformApi
import consoleApi from '@comp/platformApi/consoleApi';

//util
import userUtil from '@comp/shixunApp/userUtil';
import appHelper from '@util/appHelper';
import objectHelper from "@util/objectHelper";
import consoleHelper from "@util/consoleHelper";
import userApi from "@api/user";

const config = {
    apiConfig: {
        get: {
            url: '/portal/v4/user/center/getUserInfo',
            dataPath: 'data',
            dataColumnMapping: {
                // userName : 'name'
            }
        }
    },
};

export default {
    name: "me",
    extends : shixunPagePart,

    data() {
        return {
            apiConfig: config.apiConfig,
            title: '个人中心',
            vipList: {},
            // isExamination : true, //是否开放考试权限
            // isVip:false,
            // vipArr:[],
            // strMax:'',
            vipInfo: null,
            externalApp: externalApp,

            productData : {
                id : '',
                title : 'vip年卡',
                price : 265,
                image : ''
            },

            vipRenewalDrawer : {
                vipPrice : '',
                originalPrice : '',
            },

            activeVipType : vipTypeEnum2.getList()[0],

            vipTypeList : vipTypeEnum2.getList(),

            agreeServiceProtocol : false,

            /**
             * @member
             * @type {Object}
             */
            vipPurchasePackages : (() => {
                let map = {};
                let vipList = vipTypeEnum2.getList();
                for (let i=0; i<vipList.length; i++)
                {
                    map[vipList[i].type] = [];
                }
                return map;
            })(),

            debugArea : {
                clickTimes : 0
            }
        }
    },

    components: {
        MeVipInfo,
        bottomMenu,
        instrument,
        authCenter, purchaseCenter, materialObjectCenter, learnCenter, helpCenter,
        vipRenewalDrawer,
        bannerModule3Vue
    },
    methods: {

        copyId: function (id) {
            if (typeof (navigator.clipboard) === 'undefined') {
                appHelper.showMessage('当前浏览器阻止复制，请长按微信号进行复制。');
            } else {
                try {
                    navigator.clipboard.writeText(id);
                    appHelper.showHint('账号复制成功');
                } catch (e) {
                    appHelper.showMessage('复制失败，请长按账号进行复制。');
                }
            }
        },

        onLoadDataItem() {

            // this.dataItem.vipDueTime['1'] = '2021-02-16 14:54';

            this.dataItem = userUtil.createUser(this.dataItem);

            consoleApi.info('');
            consoleApi.info('[user] 用户资料: ');
            consoleApi.info('[user] -- 邀请码: ' + this.dataItem.introduceCode);
            consoleApi.info('[user] -- 生日: ' + this.formatDate(this.dataItem.birthday));
            consoleApi.info('[user] -- parkId: ' + this.dataItem.parkId);
            consoleApi.info('[user] -- isVip: ' + this.dataItem.isVipUser());
            consoleApi.info('[user] -- VIP due time: ' + this.dataItem.getVipDueTime());

            this.vipInfo = this.dataItem.getVipInfo();

            consoleApi.info('[user] -- ' + this.vipInfo['super'].name      + ' ' + this.vipInfo['super'].dueTime       + ' expiring: ' + this.vipInfo['super'].expiring);
            consoleApi.info('[user] -- ' + this.vipInfo['course_vod'].name + ' ' + this.vipInfo['course_vod'].dueTime  + ' expiring: ' + this.vipInfo['course_vod'].expiring);
            consoleApi.info('[user] -- ' + this.vipInfo['datum'].name      + ' ' + this.vipInfo['datum'].dueTime       + ' expiring: ' + this.vipInfo['datum'].expiring);
            consoleApi.info('[user] -- ' + this.vipInfo['atlas_vip'].name  + ' ' + this.vipInfo['atlas_vip'].dueTime   + ' expiring: ' + this.vipInfo['atlas_vip'].expiring);

            // this.handleVip(this.dataItem.vipDueTime);
        },

        loadVipInfo() {
            for (let i=0; i<this.vipTypeList.length; i++)
            {
                let vipType = this.vipTypeList[i].type;
                let vipCode = this.vipTypeList[i].code;

                let requestOptions = objectHelper.clone(vipApi.vipInfo);
                requestOptions.params = {
                    vipType : vipCode
                };

                requestManager.request(requestOptions, (error, result) => {
                    if (error)
                    {
                        appHelper.showHint(error.toString());
                        return;
                    }

                    // type: Array
                    let data = result.data;
                    this.vipPurchasePackages[vipType] = data;
                });
            }
        },

        renewal(options = {}) {

            if (!this.agreeServiceProtocol)
            {
                appHelper.showMessage('提示', '请先阅读并同意服务协议');
                return;
            }

            let type = options.type || 'super';

            switch (type)
            {
                case 'super' :
                    this.activeVipType = vipTypeEnum2.SUPER;
                    break;
                case 'course_vod' :
                    this.activeVipType = vipTypeEnum2.COURSE_VOD;
                    break;
                case 'datum' :
                    this.activeVipType = vipTypeEnum2.DATUM;
                    break;
            }

            let yearPackage = this.getVipPurchaseYearPackage(type);

            this.productData = yearPackage;

            this.$refs.vipRenewalDrawer.setProduct({
                id : yearPackage.dbValue,
                title : yearPackage.title,
                price : yearPackage.price
            });
            this.$refs.vipRenewalDrawer.open();
        },

        /**
         * @method  getVipPurchaseYearPackage
         * @param   {String}  type
         * @returns {null|Object}
         */
        getVipPurchaseYearPackage(type = 'super') {

            let vipPurchaseYearList = this.vipPurchasePackages[type];
            for (let i=0; i<vipPurchaseYearList.length; i++)
            {
                if (vipPurchaseYearList[i].timeType === 'year')
                {
                    return vipPurchaseYearList[i];
                }
            }

            return null;
        },
        changeAgreeServiceProtocol(event) {
            let status = event.status;
            this.agreeServiceProtocol = status;
        },

        onPaySuccess : function (result) {

            let orderId = result.orderId || '';
            appHelper.redirect('/vipOpenSuccess/' + orderId);
        },

        toggleDebug() {

            this.debugArea.clickTimes++;

            let dValue = 6 - this.debugArea.clickTimes;

            if (dValue == 0)
            {
                if (window.app.getDebugStatus())
                {
                    window.app.disableDebug();
                    appHelper.showHint('已关闭调试模式');
                }
                else
                {
                    window.app.enableDebug();
                    appHelper.showHint('已启用调试模式');
                }
                this.debugArea.clickTimes = 0;
            }
            else if (dValue <= 3)
            {
                appHelper.showHint(dValue, {
                    delay : 15
                });
            }
        },
        goToProfilesPage() {
            appHelper.goToPage('myProfile');
        },
        aboutUs() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/about.html');
        },
        goToArticlePage()
        {
            appHelper.goToPage('articleIndex')
        }
    },
    mounted() {
        this.loadDataItem();

        this.loadVipInfo();

        appHelper.setTitle(this.title);

        // init copy icon
        let copyAction = new ClipboardJS('.copyAction');

        copyAction.on('success', function (e) {
            consoleApi.info('[me page] 复制:', e.action);
            consoleApi.info('[me page] -- 内容:', e.text);
            consoleApi.info('[me page] -- Trigger:', e.trigger);
            appHelper.showHint('复制成功');

            e.clearSelection();
        });

        copyAction.on('error', function (e) {
            consoleApi.error('[me page] 复制:', e.action);
            consoleApi.error('[me page] Trigger:', e.trigger);
            appHelper.showMessage('当前浏览器阻止复制，请长按微信号进行复制。');
        });

        // check phone binding
        userApi.getBindPhoneStatus((status) => {

            status ? consoleApi.log('[user] 已绑定手机')
                : consoleApi.log('[user] 未绑定手机');

            if (!status)
            {
                appHelper.confirm({
                    okText : '去绑定',
                    okButtonStyle : 'color: rgb(255,25,25)',
                    content : appConfig.phoneBindingTips
                }, (status) => {
                    if (!status)
                    {
                        return;
                    }
                    appHelper.goToPage('bindPhone');
                });
            }
        });
    }
}
</script>
<style lang="scss" scoped>

.grey {
    color: #9D9E9D;
}

.user_card {

    .user_message {
        padding-top: 35px;
        padding-left: 18px;
    }

    .set_icon {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 12px;
        left: 0;
    }

    .sign_icon {
        width: 62px;
        height: 57px;
        position: absolute;
        top: 32px;
        right: 3px;
    }

    .user_photo {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        // box-shadow: 0px 6px 10px rgba(174, 174, 174, 0.8);
    }

    .user_param {
        flex: 1;
        margin-left: 14px;

        .user_name {
            span {
                height: 28px;
                font-weight: 500;
                line-height: 28px;
                color: #333333;
                /*color: #fff;*/
            }
        }

        .user_invite {
            // display: flex;
            overflow: hidden;

            .mrAndfont {
                float: left;
                height: 14px;
                padding: 0 11px;
                margin-top: 8px;
                margin-right: 6px;
                /*// background: #000;*/
                background: #000000;
                opacity: 0.26;
                /*background: rgba(0,0,0, 0.08);*/
                font-size: 10px;
                font-weight: 500;
                line-height: 14px;
                color: #FFFFFF;
                border-radius: 10px;
            }

        }
    }


}

.ad_model {
    width: 90%;
    height: 60.33px;
    margin: 0 auto;
    background: #fff;
    margin-top: 16px;
    border-radius: 8px;

    img {
        width: 100%;
        height: 100%;
    }
}

.park {
    width: 90%;
    height: 44px;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    line-height: 44px;
    margin-left: 18px;
    margin-top: 12px;
    color: #333333;
    font-weight: 500;
}

.debugArea{
    position: absolute;
    z-index: 110;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
}
.editIcon {
    background-image: url('data:image/png;base64,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');
}
.otherMenu {
    .formRow {
        display: block;
        padding: 12px 10px;
        .columnName {
            float: left;
            width: 50%;
            color: #5B616C;
        }
        .columnValue {
            float: right;
            width: 50%;
            font-size: 14px;
            text-align: right;
            color: #9D9E9D;
        }
    }
}
</style>
